import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import useTranslation from '../utils/useTranslation';
import useLawsData, { findLawContent } from '../hooks/useLawsData';
import Header from './Header';
import Footer from './Footer';

const PdfIcon = (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
    <path d="M14 3v5h5" />
    <path d="M9 13h6" />
    <path d="M9 17h4" />
  </svg>
);

export default function LawsDocumentPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { contentId } = useParams();
  const { laws, loading } = useLawsData();

  const match = findLawContent(laws, contentId);
  const { law, content } = match || {};

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [contentId]);

  const handleNavigate = (id) => {
    if (id === 'home') {
      navigate('/');
      return;
    }
    if (id === 'about') return;
    navigate('/', { state: { scrollTo: id } });
  };

  return (
    <div className="laws-doc-page">
      <Header active="laws" onNavigate={handleNavigate} />

      <main className="container laws-doc-wrap">
        {loading ? (
          <div className="laws-doc-loading">
            <div className="spinner" />
          </div>
        ) : !match || !content?.file_url ? (
          <div className="laws-doc-empty">
            <p>{t('laws_not_found')}</p>
            <button type="button" className="btn btn-primary" onClick={() => navigate('/')}>
              {t('back')}
            </button>
          </div>
        ) : (
          <>
            <header className="laws-doc-header">
              <div className="laws-doc-header-icon">{PdfIcon}</div>
              <div className="laws-doc-header-text">
                <p className="laws-doc-category">{law.name}</p>
                <h1 className="laws-doc-title">{content.title}</h1>
              </div>
            </header>

            <div className="laws-doc-viewer">
              <iframe
                src={content.file_url}
                title={content.title}
                className="laws-doc-frame"
              />
            </div>
          </>
        )}
      </main>

      <Footer />
    </div>
  );
}
